<script setup>
import { inject } from 'vue'

const close = inject('close')
const translate = inject('translate')

function tranlsate () {
  translate()
  close()
}
</script>

<template>
  <button
    role="menuitem"
    :class="{
      'text-xs': $i18n.locale === 'id'
    }"
    class="flex items-center gap-2.5 px-1 py-3 w-full text-left"
    @click="tranlsate">
    <InlineSvg :src="require('@/assets/fontawesome/regular/language.svg')" class="w-4 h-4 shrink-0"/>

    {{ $t('translate') }}
  </button>
</template>